import { Injectable, signal, computed, inject, effect } from '@angular/core';
import { Router, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { UserStateService } from './user-state.service';
import {TenantProperties} from 'libs/domain/tenant/tenant.interface';
import { SchemaService } from '../schema/schema.service';
import { catchError, firstValueFrom, of, tap } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class SchemaMembershipStateService {
  private router = inject(Router);
  private userState = inject(UserStateService);
  private schemaService = inject(SchemaService);
  private title = inject(Title)

  private user = this.userState.user
  private routeSchemaId = signal<string | null>(null);  
  
  schema = computed( () => {
    if(!this.user() || !this.routeSchemaId()) return null;
    
    const membership = this.user()!.memberships.find(
      (m) => m.schema_id === this.routeSchemaId()
    );
    return membership ?? null;
  })

  properties = signal<TenantProperties | null>(null);
  
  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateRouteSchemaId();
      }
    });

    // actualitza el Title de la pagina web
    effect(() => {
      if(this.schema()?.name){
        this.title.setTitle(`Agronic Net - ${this.schema()?.name}`);
      }else {
        this.title.setTitle(`Agronic Net`);
      }
    })
  }
  
  // s'inicialitza l'atribut properties amb els valors de les propietats del schema. 
  // El mètode retorna una promise que emet valor resol quan finalitza la crida http al backend.
  initializeSchemaProperties(schemaId: string): Promise<TenantProperties | null>{
    return firstValueFrom(
      this.schemaService.getSchemaProperties(schemaId).pipe(
        tap((props) => {
          this.properties.set(props)
          return of(this.properties());
        }),
        catchError((error) => {
          this.properties.set(null);
          return of(null);
        })
      )
    );
  }

  updateRouteSchemaId() {
    const schemaId = this.findParam(this.router.routerState.snapshot.root, 'id');
    this.routeSchemaId.set(schemaId);
    //console.log(`SchemaId: ${this.routeSchemaId()}`)
  }
  
  findParam(route: ActivatedRouteSnapshot, key: string): string | null {
    let currentRoute: ActivatedRouteSnapshot | null = route;
    while (currentRoute) {
      const value = currentRoute.paramMap.get(key);
      if (value) return value;
      currentRoute = currentRoute.firstChild ?? null;
    }
    return null;
  }
}
